var React = require('react');

function WebinarInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.7998 19.5H15.7998M11.7998 15.5V19.5M6.5998 15.5H16.9998C18.68 15.5 19.52 15.5 20.1618 15.173C20.7263 14.8854 21.1852 14.4265 21.4728 13.862C21.7998 13.2202 21.7998 12.3802 21.7998 10.7V6.3C21.7998 4.61984 21.7998 3.77976 21.4728 3.13803C21.1852 2.57354 20.7263 2.1146 20.1618 1.82698C19.52 1.5 18.68 1.5 16.9998 1.5H6.5998C4.91965 1.5 4.07957 1.5 3.43783 1.82698C2.87335 2.1146 2.41441 2.57354 2.12679 3.13803C1.7998 3.77976 1.7998 4.61984 1.7998 6.3V10.7C1.7998 12.3802 1.7998 13.2202 2.12679 13.862C2.41441 14.4265 2.87335 14.8854 3.43783 15.173C4.07957 15.5 4.91965 15.5 6.5998 15.5Z","stroke":"#407A7D","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

WebinarInline.defaultProps = {"width":"23","height":"21","viewBox":"0 0 23 21","fill":"none"};

module.exports = WebinarInline;

WebinarInline.default = WebinarInline;
